export const InstructionsGraphics = () => {
  return (
    <svg
      width="173"
      height="115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="13.615"
        width="74.655"
        height="28.931"
        rx="1"
        fill="#F8F8F8"
        stroke="#E1E1E1"
        strokeWidth="2"
      />
      <rect
        x="83.034"
        y="13.615"
        width="74.655"
        height="100.207"
        rx="1"
        fill="#F8F8F8"
        stroke="#E1E1E1"
        strokeWidth="2"
      />
      <rect
        x="1"
        y="49.926"
        width="74.655"
        height="27.586"
        rx="1"
        fill="#EAF6F4"
        stroke="#125970"
        strokeWidth="2"
      />
      <rect
        x="1"
        y="84.891"
        width="74.655"
        height="28.931"
        rx="1"
        fill="#F8F8F8"
        stroke="#E1E1E1"
        strokeWidth="2"
      />
      <path
        d="M166.82 4.19l-1.863-1.366-3.59 5.56 1.863 1.367 3.59-5.56zM158.056.452L155.841 0l-1.186 6.61 2.215.453 1.186-6.611z"
        fill="#E1E1E1"
      />
      <circle cx="64.5" cy="67.322" r="5.5" fill="#125970" />
      <path
        d="M172.665 12.51l-1.045-2.137-5.614 3.12 1.045 2.137 5.614-3.12z"
        fill="#E1E1E1"
      />
      <path
        stroke="#E1E1E1"
        strokeWidth="3"
        d="M94.138 27.254h32.276M94.138 77.012h32.276M94.138 36.668h52.448"
      />
      <path fill="#E1E1E1" d="M94.138 47.58h14.793v18.828H94.138z" />
      <rect
        x="8.069"
        y="22.029"
        width="13.448"
        height="13.448"
        rx="2"
        fill="#E1E1E1"
      />
      <rect
        x="8.069"
        y="93.305"
        width="13.448"
        height="13.448"
        rx="2"
        fill="#E1E1E1"
      />
      <rect
        x="8.069"
        y="56.994"
        width="13.448"
        height="13.448"
        rx="2"
        fill="#7DA9B3"
      />
      <path
        fill="#E1E1E1"
        d="M94.138 83.891h52.448v18.828H94.138zM112.966 47.58h14.793v18.828h-14.793zM131.793 47.58h14.793v18.828h-14.793z"
      />
      <mask
        id="a"
        maskUnits="userSpaceOnUse"
        x="61"
        y="65.822"
        width="20"
        height="26"
        fill="#000"
      >
        <path fill="#fff" d="M61 65.822h20v26H61z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M64 70.822l2.76 16.097 4.293-2.8 2.747 4.749 2.989-2.146-3.254-4.222 3.802-2.48L64 70.822z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64 70.822l2.76 16.097 4.293-2.8 2.747 4.749 2.989-2.146-3.254-4.222 3.802-2.48L64 70.822z"
        fill="#000"
      />
      <path
        d="M66.76 86.92l-1.972.337.514 3 2.55-1.663-1.093-1.675zM64 70.821l1.135-1.646-3.909-2.696.803 4.68L64 70.822zm7.053 13.297l1.732-1.002-1.057-1.826-1.767 1.153 1.093 1.675zm2.747 4.749l-1.731 1.001 1.105 1.91 1.793-1.286-1.167-1.625zm2.989-2.146l1.166 1.625 1.681-1.207-1.263-1.639-1.584 1.221zM73.535 82.5l-1.093-1.675-1.812 1.182 1.32 1.714 1.585-1.22zm3.802-2.48l1.093 1.676 2.497-1.63-2.454-1.692-1.136 1.647zm-8.606 6.561l-2.76-16.097-3.942.676 2.76 16.097 3.942-.676zm1.23-4.138l-4.294 2.801 2.185 3.35 4.294-2.8-2.185-3.35zm5.57 5.424l-2.746-4.75-3.463 2.003 2.747 4.75 3.462-2.003zm.091-2.77l-2.988 2.146 2.333 3.25 2.988-2.146-2.333-3.25zm-3.671-1.376l3.254 4.222 3.168-2.442-3.254-4.222-3.168 2.442zm4.294-5.376l-3.803 2.48 2.185 3.35 3.803-2.48-2.185-3.35zm-13.38-5.876l13.337 9.198 2.27-3.293-13.337-9.198-2.27 3.293z"
        fill="#fff"
        mask="url(#a)"
      />
    </svg>
  );
};
